{
  "title": "Take in consigned cards",
  "intro": "Who brings the cards, the cards one by one, then one button. The cards are not on sale until you finish their product page.",
  "load_failed": "This intake could not be opened.",
  "steps": {
    "label": "Steps",
    "consignor": "Consignor",
    "cards": "Cards",
    "review": "Check and take in"
  },
  "consignor": {
    "search": "Find the consignor",
    "search_hint": "Name, カナ, CON- number or e-mail.",
    "results": "Consignors found",
    "none": "Nobody found.",
    "create": "Add a new consignor",
    "load_failed": "The consignor could not be loaded.",
    "change": "Someone else",
    "location": "Shop that takes the cards",
    "location_hint": "The cards are kept here and written in its 古物台帳.",
    "start": "Start"
  },
  "block": {
    "kyc_missing": "本人確認 has not been done for this person.",
    "kyc_missing_why": "古物営業法: the shop checks the ID of everyone who hands in second-hand goods before taking them.",
    "kyc_pending": "本人確認 is waiting for a check.",
    "kyc_pending_why": "Confirm the check on the consignor's page first (古物営業法).",
    "kyc_expired": "The 本人確認 of this person has ended.",
    "kyc_expired_why": "古物営業法: an ended check cannot be used — do 本人確認 again before taking the cards.",
    "kyc_rejected": "The last 本人確認 was not accepted.",
    "kyc_rejected_why": "古物営業法: do 本人確認 again with an ID the shop accepts.",
    "suspended": "This consignor is paused.",
    "suspended_why": "Open the consignor's page to see why and to switch them on again.",
    "closed": "This consignor is closed.",
    "closed_why": "A closed consignor cannot hand in new cards.",
    "agreement": "The current consignment agreement is not signed yet.",
    "agreement_why": "The consignor signs the agreement once; after that every intake uses it.",
    "do_check": "Do 本人確認 now",
    "record_agreement": "They signed version {{version}} at the shop",
    "open_consignor": "Open the consignor's page"
  },
  "kinds": {
    "raw_single": "Card",
    "graded_single": "Graded card",
    "sealed_product": "Sealed box"
  },
  "entry": {
    "title": "Card {{n}}",
    "kind": "What is it?",
    "card": "Scan or type the card",
    "title_label": "Name on the label",
    "title_hint": "Filled in from the card you choose — change it if needed.",
    "quantity": "How many boxes",
    "quantity_hint": "Each box gets its own label.",
    "weight": "Weight of the box",
    "weight_hint": "Weigh the item itself (the box as it is), without the mailer or bubble wrap — the shop's packing weight is added on top for the shipping cost.",
    "price": "Agreed selling price",
    "price_help": "The price customers pay (税込), agreed with the consignor.",
    "agreed_min": "Lowest price they accept",
    "agreed_min_hint": "Optional. A later price below this always needs their OK.",
    "commission": "Shop commission",
    "commission_hint": "Empty = {{percent}} % (this consignor's usual).",
    "commission_hint_rule": "Empty = the shop's commission rules.",
    "company": "Grading company",
    "grade": "Grade",
    "cert": "Certificate number",
    "discount": "Discount allowed (up to 10 %)",
    "discount_hint": "The consignor says the shop may take up to 10 % off in a sale.",
    "photos": "Photos (1–2)",
    "features": "Marks or damage",
    "features_hint": "Written in the 古物台帳, e.g. \"small scratch on the back\".",
    "add": "Add this card",
    "enter_hint": "Enter adds the card and starts the next one."
  },
  "lines": {
    "caption": "Cards of this intake",
    "card": "Card",
    "condition": "Condition",
    "price": "Agreed price",
    "terms": "Terms",
    "status": "State",
    "remove": "Remove",
    "remove_line": "Remove card {{n}}",
    "removed": "Card removed.",
    "empty": "No cards yet — add the first one below.",
    "min": "Lowest",
    "commission": "Commission {{percent}} %",
    "commission_default": "Usual commission",
    "discount_ok": "Discount up to {{percent}} %",
    "discount_no": "No discount",
    "photos_one": "{{count}} photo",
    "photos_other": "{{count}} photos",
    "weight": "{{grams}} g",
    "pending": "Not taken in yet",
    "created": "Taken in",
    "failed": "Could not be taken in"
  },
  "problems": {
    "title": "Write the name of the card.",
    "rank": "Choose Rank A–D.",
    "grading_company": "Choose the grading company.",
    "grade": "Choose the grade.",
    "cert": "Type the certificate number.",
    "quantity": "Between 1 and 50 boxes.",
    "weight": "Type the weight in grams (1 to 100,000).",
    "price": "Type the price in yen.",
    "agreed_min": "Type the lowest price in yen.",
    "agreed_min_above": "The lowest price is higher than the selling price.",
    "commission": "A number between 0 and 100.",
    "photos": "At most 10 photos.",
    "photos_busy": "Wait until the photos are uploaded.",
    "reason": "Write a short reason.",
    "fix_first": "Fix the marked boxes first."
  },
  "summary": {
    "agreement": "Agreement version {{version}}",
    "so_far_one": "{{count}} card so far",
    "so_far_other": "{{count}} cards so far",
    "next": "Check and take in",
    "cards": "Cards",
    "total": "Agreed prices (税込)",
    "what_happens": "Taking in makes each card a draft product (not on sale), writes the 古物台帳 受入 rows and puts the cards in stock. Then print the 委託契約書 / 預り証 (2 copies) and the labels.",
    "back": "Back to the cards",
    "complete": "受付する · Take in"
  },
  "done": {
    "title_one": "{{count}} card taken in.",
    "title_other": "{{count}} cards taken in.",
    "toast_one": "{{count}} card taken in.",
    "toast_other": "{{count}} cards taken in.",
    "some_failed": "{{created}} taken in, {{failed}} could not be taken in.",
    "what_happened": "They are written in the 古物台帳 and in stock, not on sale yet. Open each card to finish its product page.",
    "retry": "Try the other cards again",
    "documents": "委託契約書 / 預り証",
    "documents_pending": "Making the 委託契約書…",
    "documents_failed": "The 委託契約書 could not be made yet — the shop system tries again by itself.",
    "documents_unavailable": "The system cannot make the 委託契約書 / 預り証 yet (the paper design is not ready). Hand over the paper form for now — the card intake itself is saved.",
    "documents_todo": "Open the to-do list",
    "document_n": "Document {{n}}",
    "labels": "Print labels",
    "to_items": "See these cards",
    "again": "More cards from this person",
    "ledger_one": "古物台帳: {{count}} 受入 row written.",
    "ledger_other": "古物台帳: {{count}} 受入 rows written.",
    "ledger_open": "Open the 古物台帳"
  },
  "cancel": {
    "button": "Cancel this intake",
    "title": "Cancel this intake?",
    "consequence": "Nothing was taken in yet; the cards typed so far are thrown away.",
    "confirm": "Cancel intake",
    "done": "Intake cancelled.",
    "already": "This intake was cancelled.",
    "new": "Start a new intake"
  },
  "board": {
    "intro": "Every consigned card by its state. Drag a card to review, pause or close it; the other states change by themselves.",
    "new_intake": "Take in cards",
    "drafts_one": "{{count}} intake is not finished:",
    "drafts_other": "{{count}} intakes are not finished:",
    "draft_cards_one": "{{count}} card",
    "draft_cards_other": "{{count}} cards",
    "views": "How to show the cards",
    "tab_board": "Board",
    "tab_list": "Table",
    "tab_prices": "Price approvals",
    "only_of": "Only the cards of",
    "show_all": "Everyone",
    "search": "Search cards",
    "search_hint": "Name, label code or certificate",
    "drag_hint": "Tap a card to see everything about it. On a keyboard: open the card and use its buttons.",
    "locked": "Changes by itself",
    "auto_listed": "When its product page is on sale.",
    "auto_reserved": "While a customer's order holds it.",
    "auto_sold": "When a customer pays for it.",
    "auto_returned": "When it is handed back.",
    "refuse_automatic": "\"{{stage}}\" changes by itself (when the card sells, is on sale or is handed back) — it cannot be chosen by hand.",
    "refuse_not_from_here": "This card cannot go to \"{{stage}}\" from where it is now."
  },
  "list": {
    "reference": "Label code",
    "card": "Card",
    "stage": "State",
    "consignor": "Consignor",
    "received": "Taken in"
  },
  "item": {
    "title": "Consigned card",
    "load_failed": "This card could not be loaded.",
    "intake": "Intake {{reference}}, card {{line}}",
    "price": "Selling price",
    "payout": "Consignor gets (about)",
    "finish_product": "Finish the product page",
    "open_product": "Open the product page",
    "create_product": "Make the product again",
    "retried": "Trying again.",
    "discount_title": "Discount",
    "discount": "The shop may take up to {{percent}} % off",
    "discount_reason": "Changed on the consigned card's page",
    "discount_locked": "Only the consignor can change this now (their choice in the portal).",
    "status_title": "State",
    "moved": "Now: {{stage}}.",
    "notes": "Notes",
    "save_notes": "Save notes",
    "saved": "Saved.",
    "timeline": "History",
    "actor_staff": "Staff",
    "actor_consignor": "Consignor",
    "actor_system": "Automatic"
  },
  "move": {
    "to": {
      "received": "Back to \"received\"",
      "under_review": "Check it first",
      "ready_to_list": "Ready to sell",
      "paused": "Pause",
      "closed": "Close"
    },
    "auto_listed": "On sale — it changes by itself when a customer orders or buys it.",
    "auto_reserved": "In a customer's order — it changes by itself when they pay or the order ends.",
    "auto_sold": "Sold — it changes by itself when the consignor is paid.",
    "auto_returned": "Handed back to the consignor.",
    "auto_generic": "This state changes by itself.",
    "confirm_title": "Change to \"{{stage}}\"?",
    "confirm_consequence": "The consignor sees the new state in their portal.",
    "confirm": "Change"
  },
  "price": {
    "change": "New price",
    "new_title": "Ask for a new selling price",
    "new_intro": "The consignor approves the new price in their portal (or it is approved by itself after the days they chose).",
    "current": "Price now",
    "minimum": "Lowest they accept",
    "no_minimum": "Not set",
    "new_price": "New price",
    "reason": "Why",
    "below_min_warning": "Below the lowest price they accept — it will not be approved by itself.",
    "how_it_works": "The price on the website changes only after the consignor says yes.",
    "send": "Send to the consignor",
    "sent": "Sent. The consignor is asked in their portal.",
    "applied": "The new price is on sale.",
    "open_title": "Price waiting for an answer",
    "waiting_consignor": "Waiting for the consignor's answer.",
    "waiting_staff": "The consignor is waiting for the shop's answer.",
    "waiting_nobody": "Nothing to answer.",
    "proposed_by_staff": "The shop asked for",
    "proposed_by_consignor": "The consignor asks for",
    "counter_of": "The consignor answered with",
    "below_min_note": "This is below the lowest price agreed at intake.",
    "needs_manager": "A big price drop — a manager must approve.",
    "auto_on": "Approved by itself on",
    "note": "Note",
    "note_hint": "Optional — saved with the answer.",
    "approve": "Approve this price",
    "approved": "Approved. The new price is on sale.",
    "decline": "Say no",
    "declined": "Declined.",
    "withdraw": "Take the request back",
    "withdrawn": "Request taken back.",
    "close": "Close",
    "pending_line": "Price waiting for an answer:"
  },
  "prices": {
    "from": "Price now",
    "to": "New price",
    "waiting": "Who answers",
    "waiting_staff": "The shop",
    "waiting_consignor": "The consignor",
    "waiting_nobody": "Nobody",
    "since": "Since",
    "status": "State",
    "status_pending": "Waiting",
    "status_countered": "Consignor answered with a price",
    "status_approved": "Approved",
    "status_auto_approved": "Approved by itself",
    "status_rejected": "Consignor said no",
    "status_expired": "Ended",
    "status_cancelled": "Taken back",
    "view_open": "Waiting",
    "view_countered": "Consignor answered"
  },
  "return": {
    "button": "Give back to the consignor",
    "confirm_title": "Give this card back?",
    "confirm_consequence": "It comes off the website at once. The 古物台帳 払出 row is written when it is handed over or sent.",
    "confirm": "Start giving back",
    "started": "Giving back started — the card is off the website.",
    "open_panel": "Open the card to give it back.",
    "title": "Giving back {{reference}}",
    "status": {
      "requested": "Asked — take the card out of the showcase.",
      "preparing": "Being taken out of the showcase.",
      "ready": "Ready — hand it over at the shop or send it.",
      "handed_over": "Handed over.",
      "handed_over_pending_inventory": "Handed over — the stock is being updated.",
      "shipped": "Sent.",
      "shipped_pending_inventory": "Sent — the stock is being updated.",
      "cancelled": "Cancelled."
    },
    "prepare": "I am taking it out",
    "ready": "It is ready",
    "at_shop": "At the shop",
    "signature": "Photo of the signed return slip",
    "hand_over": "Handed over",
    "by_post": "By post",
    "carrier": "Carrier",
    "tracking": "Tracking number",
    "ship": "Sent",
    "sync": "Update the stock again",
    "slip": "返還受領書",
    "cancel": "Cancel giving back",
    "cancel_consequence": "The card goes back to where it was.",
    "saved": "Saved.",
    "done_preparing": "Taking it out.",
    "done_ready": "Ready — the consignor is told.",
    "done_handed_over": "Handed over. Written in the 古物台帳.",
    "done_shipped": "Sent. Written in the 古物台帳.",
    "done_cancelled": "Giving back cancelled."
  },
  "requests": {
    "title": "Consignment request",
    "intro": "People who asked on the website to consign cards. Contact them, then accept (a consignor + an intake with their cards) or say no.",
    "reference": "Number",
    "name": "Name",
    "cards": "Cards",
    "status_col": "State",
    "received": "Received",
    "status": {
      "new": "New",
      "contacted": "Contacted",
      "accepted": "Accepted",
      "rejected": "Declined",
      "converted": "Consignor made"
    },
    "view_new": "New",
    "view_contacted": "Contacted",
    "load_failed": "This request could not be loaded.",
    "language": "Language",
    "asking": "Wants",
    "notes": "Shop notes",
    "note": "Note",
    "note_hint": "Saved with the request (not sent to the customer).",
    "accept": "Accept and prepare the intake",
    "contacted": "We contacted them",
    "reject": "Say no",
    "reject_hint": "Saying no sends a polite e-mail in their language.",
    "saved": "Saved.",
    "done_contacted": "Marked as contacted.",
    "done_rejected": "Declined — the e-mail is on its way.",
    "open_intake": "Open the intake",
    "convert_title": "Accept the request",
    "convert_intro": "Check each card: what it is, Rank A–D or the grade, and the agreed price. 本人確認 and the agreement come at the intake.",
    "convert": "Make the consignor and the intake",
    "card_n": "Card {{n}}"
  }
}
